import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl';
import downloadIcon from "./img/download-icon.png";
import "./styles/LinksDownloadFormats.scss";
import { Query } from 'react-apollo';
import meQuery from 'utils/queries/MeQuery';
import { EU_BUTTONS_TEXTS, FORMATS_NAMES, handleDownloadFormat } from './constants';
import LoadingMessage from 'utils/components/LoadingMessage';

const LinksDownloadFormats = ({ authorizationFormats, loadingFormats }) => {
  const formatsOrFormat = authorizationFormats?.extractedFiles;

  return (
    <Query query={meQuery}>
      {({ loading, error, data }) => {
        if (loading || error) return null;

        const userInstance = data?.me?.profile?.geographicInstance?.edges?.[0]?.node?.code;
        const hasMultipleFormats = formatsOrFormat?.length > 1;
        const isEU = userInstance === "eu";
        const isLATAM = userInstance === "la";

        if (loadingFormats) {
          return (
            <div key="loader" className="text-center col-12 pt-3">
              <LoadingMessage />
            </div>
          );
        }

        // Helper: render icon
        const icon = (
          <img
            src={downloadIcon}
            width={13}
            height={13}
            alt="download icon"
            className="ml-1"
          />
        );

        return (
          <div className="col-12 d-lg-flex mt-4 gap-4">
            {isEU && hasMultipleFormats ? (
              EU_BUTTONS_TEXTS.map(({ index, id, defaultMessage, order }) => (
                <button
                  key={id}
                  onClick={() =>
                    handleDownloadFormat(
                      formatsOrFormat[index].url,
                      userInstance,
                      order
                    )
                  }
                  className="step-0-form__submit-btn introduction-disclaimer__btn mb-2 mb-lg-0 px-lg-5 rounded-5"
                >
                  <FormattedMessage
                    id={id}
                    defaultMessage={defaultMessage}
                    values={{ icon }}
                  />
                </button>
              ))
            ) : (
              <button
                onClick={() =>
                  handleDownloadFormat(isLATAM ? formatsOrFormat : formatsOrFormat[0]?.url, userInstance)
                }
                className="step-0-form__submit-btn introduction-disclaimer__btn px-lg-5 rounded-5"
              >
                <FormattedMessage
                  id="ProjectStepFormDisclaimer.button.downloadOnlyFormat"
                  defaultMessage="Descargar formato{plural} {icon}"
                  values={{ 
                    icon,
                    plural: isLATAM ? "s" : ""
                  }}
                />
              </button>
            )}
          </div>
        );
      }}
    </Query>
  );
}

export default LinksDownloadFormats